import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'

export function loyaltyContext(account: App.LoyaltyAccount | undefined) {
  return comluxgroup.createLoyalty_1_0_2({
    isMember: !!account,
    tier: account?.tier,
    membershipNumber: account?.accountNumber,
    points: account?.points,
    statusCredits: account?.statusCredits,
  })
}
